// ============================================================
// Shop auth helper — redirect guest ke login
// ============================================================

export function requireAuth(redirectUrl) {
  const target = redirectUrl || window.location.pathname + window.location.search;
  const store = window.Alpine?.store('auth');

  if (!store?.isLoggedIn) {
    window.location.href = `/login?redirect=${encodeURIComponent(target)}`;
    return false;
  }

  return true;
}

export function shopApi(path) {
  return `/api/v1${path}`;
}
